import { ChangeDetectionStrategy, Component, inject, OnInit } from "@angular/core";
import { ViewEncapsulation } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { Loading } from "./core/components/loading";
import { LoadingService } from "./core/services/loading";
import { IdleSessionService } from "@azm/core/services/idle-session";
import { DialogService } from "@azm/shared/components/overlay/dialog/services/dialog.service";

@Component({
	selector: "app-root",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	imports: [RouterOutlet, Loading],
	templateUrl: "./app.html",
})
export class App implements OnInit {
	readonly isLoading = inject(LoadingService).isLoading;

	readonly #idleSessionService = inject(IdleSessionService);
	readonly #dialogService = inject(DialogService);

	ngOnInit(): void {
		this.#idleSessionService.start();
		this.#bindBackForwardRecovery();
	}

	#bindBackForwardRecovery(): void {
		window.addEventListener("pageshow", (event: PageTransitionEvent) => {
			if (!event.persisted) {
				return;
			}

			document.body.classList.remove("cdk-global-scrollblock");
			document.body.style.removeProperty("overflow");
			document.body.style.removeProperty("position");
			this.#dialogService.closeAll();
		});
	}
}
